import { parseCurrency } from '@helper/parseCurrency'

export const parseCommercialBudgetDataFooter = (data: any[]): any[] => {
  const res = []

  let realProj = 0
  let levOrc = 0
  let cresc = 0
  let orca = 0
  let cresAjust = 0
  data.forEach(obj => {
    return (realProj += obj.previsaoAnoAtual)
  })
  data.forEach(obj => {
    return (levOrc += obj.previsaoAlgoritmo)
  })
  data.forEach(obj => {
    return (cresc += obj.previsaoAumentoPercentual)
  })
  data.forEach(obj => {
    return (orca += obj.previsaoAlgoritmo)
  })
  data.forEach(obj => {
    return (cresAjust += obj.previsaoAumentoPercentualAjusteFino)
  })
  res.push({
    'orcamento-id': '',
    'orcamento-ano': '',
    'orcamento-mes': '',
    'orcamento-empresa': '',
    'orcamento-loja': '',
    'orcamento-categoria': '',
    'orcamento-fator-venda': '',
    'orcamento-real-proj': parseCurrency({
      value: realProj,
      country: 'pt-br'
    }),
    'orcamento-prev-orcamento': parseCurrency({
      value: levOrc,
      country: 'pt-br'
    }),
    'orcamento-alterado': '',
    'orcamento-crescimento': parseCurrency({
      value: cresc,
      country: 'pt-br'
    }),
    'orcamento-ajustado': parseCurrency({
      value: orca,
      country: 'pt-br'
    }),
    'orcamento-crescimento-ajustado': parseCurrency({
      value: cresAjust,
      country: 'pt-br'
    }),
    'orcamento-du-real-proj': '',
    'orcamento-du-prev-orcamento': '',
    'orcamento-du-ajustado': '',
    'orcamento-du-crescimento-ajustado': ''
  })

  return res
}
